import React from 'react'

export default function ProjectItem(props) {
  const {name,link,URI}=props.data;
  return (
    <>
      <img title={name} alt={name} src={link} />
      <a rel='noreferrer' title={name} target='_blank' href={URI} className='project-details'><button >Visit Site</button></a>
    </>
  )
}
